import { render, staticRenderFns } from "./MmDeliveryNoticeLabel.vue?vue&type=template&id=a8610ee0&scoped=true&"
import script from "./MmDeliveryNoticeLabel.vue?vue&type=script&lang=js&"
export * from "./MmDeliveryNoticeLabel.vue?vue&type=script&lang=js&"
import style0 from "./MmDeliveryNoticeLabel.vue?vue&type=style&index=0&id=a8610ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8610ee0",
  null
  
)

export default component.exports